<template>
    <div class="mx_content">
        <div class="mx_title">
            <div class="title_left">
                <span>印章信息</span>
            </div>
            <div class="title_right">
                <el-button v-if="canEdit" size="mini" @click="addMx">添加</el-button>
            </div>
        </div>
        <el-table :data="listData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="corpName" label="印章所属单位" align="center" width="200px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" :rules="feeDescRules" name="印章所属单位">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-input v-model="scope.row.corpName" v-can-edit :can-edit="canEdit" name="corpName" placeholder="请输入印章所属单位" />
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                    <div v-else>{{ scope.row.corpName }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="stampType" label="印章类型" align="center">
                <template slot-scope="scope">
                    <div>
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" :rules="feeDescRules" name="印章类型">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-checkbox-group v-model="scope.row.itemArr" @change="changeFn">
                                    <el-checkbox v-for="(option, index) in stampTypeList" :key="index" :disabled="canEdit === 0" :label="option.label">{{ option.text }}</el-checkbox>
                                </el-checkbox-group>
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="memo" label="备注" align="center" width="350px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" :rules="feeDescRules" name="备注">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <el-input v-model="scope.row.memo" v-can-edit :can-edit="canEdit" name="memo" placeholder="请输入备注" />
                        <!-- </el-tooltip>
                        </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.memo }}</div>
                </template>
            </el-table-column>

            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const { uuid } = require('@/global/utils/index.js')
import moment from 'moment'
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }

        // 自定义属性
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        const feeDescRules = {
            required: true
        }
        const occureDateRules = {
            required: true
        }

        const feeAmountRules = {
            required: true
        }

        const handleFeeAmountInput = (value) => {
            // 这里可以添加对费用金额的其他校验逻辑
        }

        // 如果需要，可以在这里添加对ValidationProvider实例的引用逻辑
        // 例如：
        // const { validate } = useValidation();
        // ...

        return {
            feeTypeRules,
            feeAmountRules,
            handleFeeAmountInput,
            feeDescRules,
            occureDateRules
            // ... 其他响应式引用
        }
    },
    data() {
        return {
            moduleInfo: {},
            loginUser: this.$store.getters.loginUser,
            listData: [],
            stampTypeList: [
                { label: '1', text: '法定代表人名章（签名章）' },
                { label: '2', text: '公章' },
                { label: '3', text: '合同专用章' },
                { label: '4', text: '财务专用章' }
            ]
        }
    },
    computed: {},
    watch: {
        listData: {
            handler(newVal, oldVal) {
                // 当listData发生变化时，更新vo.passenger[listName]
                this.vo.passenger[this.listName] = newVal
            },
            deep: true
        }
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        this.moduleInfo = {
            delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
            addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
            insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
            moduleCode: this.module,
            updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
            listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
            getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
            querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        }
        this.getListData()
    },
    updated() {},
    methods: {
        async getListData(model) {
            if (this.isHttp) {
                const data = [{ compare: '=', field: 'formId', merge: false, value: this.vo.id }]
                const res = await this.$app.querydata(this.moduleInfo.querydata, data)
                if (res.code === 'success') {
                    this.listData = res.body.listdata
                }
            } else if (this.listName) {
                if (this.vo.passenger && this.vo.passenger[this.listName] && this.vo.passenger[this.listName].length > 0) {
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (!item.formId) {
                            item.formId = this.vo.id
                        }
                        if (!item.id) {
                            item.id = uuid()
                        }
                        if (!item.creatorId) {
                            item.creatorId = this.loginUser.id
                        }
                        if (!item.createTime) {
                            // 获取当前时间
                            const now = moment()
                            // 格式化当前时间
                            const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                            item.createTime = formattedNow
                        }
                    })
                    this.listData = this.vo.passenger[this.listName]
                    if (this.listData.length > 0) {
                        this.listData.forEach((item) => {
                            if (item.stampType) {
                                item.itemArr = Array.from(item.stampType)
                            } else {
                                item.itemArr = []
                            }
                        })
                    }
                }
            } else {
                console.log('请传递listName参数或改用接口获取数据')
            }
        },
        changeFn(val) {
            if (this.listData.length > 0) {
                this.listData.forEach((item) => {
                    if (item.itemArr.length > 0) {
                        item.itemArr = item.itemArr.filter((item1) => item1 !== ',')
                    }
                })
            }
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            const index = this.listData.findIndex((item) => item.id === row.id)
            if (index !== -1) {
                // 使用splice方法删除该项
                this.listData.splice(index, 1)
            } else {
                console.error('未找到要删除的数据项')
            }
        },
        addMx() {
            this.$http({
                url: this.moduleInfo.addNewUrl,
                method: 'post'
            }).then((res) => {
                if (res.code === 'success') {
                    res.body.vo.formId = this.vo.id
                    res.body.vo.creatorId = this.loginUser.id

                    // 获取当前时间
                    const now = moment()
                    // 格式化当前时间
                    const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                    res.body.vo.createTime = formattedNow

                    this.listData.push(res.body.vo)
                    if (this.listData.length > 0) {
                        this.listData.forEach((item) => {
                            if (!item.stampType) {
                                item.itemArr = []
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table .el-link--inner {
    width: 100%;
}
.mx_content /deep/ .el-table__body-wrapper tr td:last-child {
    border-right-color: #e2e7ed !important;
}
.mx_content {
    .mx_title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #999;
        justify-content: space-between;
        // background: #f2f5fb;
        padding: 0 10px;
    }
}

.attachment-link-wrapper {
    display: flex;
    align-items: center;
    /* 如果需要垂直居中 */
    justify-content: space-between;
    /* 确保链接和按钮之间有间隔，并分别位于开始和结束位置 */
    .el-lint-inner {
        width: 100%;
    }
}

.attachment-link {
    flex: 1;
    /* 占据可用空间，但不会挤压删除按钮 */
    overflow: hidden;
    /* 隐藏超出容器的部分 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    /* 其他你需要的样式 */
}

.remove-button {
    /* 确保按钮始终可见，并位于行尾 */
    /* 你可以添加更多的样式来美化按钮 */
}
</style>
